angular.module('backOffice').filter(
    'camelCase',
    () =>
        function (input) {
            input = input || '';

            return input.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        }
);
